<script setup>
/* eslint-disable */
import { to } from "await-to-js";
import FlagIcon from "vue3-flag-icons";
import isEmpty from "lodash/isEmpty";
import includes from "lodash/includes";
import dayjs from "dayjs";
import { saveAs } from 'file-saver';
import { onMounted, ref, watch } from "vue";
import {
  Search,
  More
} from '@element-plus/icons-vue'
//import { useRouter } from "vue-router";
import { interceptor } from "@dutypay/utilities";
const companiesList = ref([]);
const selectedCompany = ref("");
const reportingPeriods = ref([]);
const selectedReportingPeriod = ref("");
const businessActions = ref([]);
const countBusinessActions = ref(0);
const page = ref(1);
const pageSize = ref(10);
const loadingReportingPeriods = ref(false);
const loadingBusinessActions = ref(false);

watch(selectedReportingPeriod, (newValue, oldValue) => {
  if(newValue != oldValue){
    page.value = 1
  }
});

onMounted(async () => {
  await getCompanies();
});

const getCompanies = async (query) => {
  const envStore = useEnvStore();
  if (query) {
    let err, res;
    [err, res] = await to(
      interceptor.get(`${envStore.apiUrls.dutypay  }/api/v0/my/companies/all`, {
          params: {
            search: query
          }
        }
      )
    );
    if (err) {
      console.log(err)
      companiesList.value = [];
    }
    companiesList.value = res.data.result.companies;
  }
}


const getReportingPeriods = async () => {
  loadingReportingPeriods.value = true;
  reportingPeriods.value = [];
  selectedReportingPeriod.value = "";
  businessActions.value = [];
  if (selectedCompany.value) {
    const envStore = useEnvStore();
    let err, res;
    [err, res] = await to(
      interceptor.get(
        `${envStore.apiUrls.dutypay}/api/v0/tools/reporting-periods/${selectedCompany.value}`,
        {
          params: {},
        }
      )
    );
    if (err) {
      reportingPeriods.value = [];
      loadingReportingPeriods.value = false;
      return;
    }
    reportingPeriods.value = res.data.result;
  }
  loadingReportingPeriods.value = false;
};

const getBusinessActions = async () => {
  loadingBusinessActions.value = true;
  if (selectedCompany.value && selectedReportingPeriod.value) {
    const envStore = useEnvStore();
    let err, res;
    [err, res] = await to(
      interceptor.get(
        `${envStore.apiUrls.dutypay}/api/v0/tools/business-actions/${selectedCompany.value}/${selectedReportingPeriod.value}/${page.value}/${pageSize.value}`,
        {
          params: {},
        }
      )
    );
    if (err) {
      page.value = 1;
      businessActions.value = [];
      countBusinessActions.value = 0;
      loadingBusinessActions.value = false;
      return;
    }
    businessActions.value = res.data.result.businessActions;
    countBusinessActions.value = res.data.result.countBusinessActions;
  } else {
    page.value = 1;
    businessActions.value = [];
    countBusinessActions.value = 0;
  }
  loadingBusinessActions.value = false;
};

const downloadInvoicePDF = async (businessActionId) => {
  const envStore = useEnvStore();
    let error, response;
    [error, response] = await to(
        interceptor.post(`${envStore.apiUrls.dutypay}/api/v0/tools/form-data/${selectedCompany.value}/${businessActionId}/invoicePDF`, 
        {},
        {
            responseType: "arraybuffer",
        })
    );

    if (error) {
        if (envStore.debug) {
            throw error;
        }
        return;
    }

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    // Temporären Link erzeugen und Klick simulieren
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `invoice-${businessActionId}.pdf`); // Dateiname
    document.body.appendChild(link);
    link.click();

    // Aufräumen
    link.remove();
    window.URL.revokeObjectURL(url);
};

const downloadSIIXML = async (businessActionId) => {
  const envStore = useEnvStore();
    let error, response;
    [error, response] = await to(
        interceptor.post(`${envStore.apiUrls.dutypay}/api/v0/tools/form-data/${selectedCompany.value}/${businessActionId}/SIIXML`, 
        {},
        {
            responseType: "arraybuffer",
        })
    );

    if (error) {
        if (envStore.debug) {
            throw error;
        }
        return;
    }

    const blob = new Blob([response.data], { type: "application/xml" });
    const url = window.URL.createObjectURL(blob);

    // Temporären Link erzeugen und Klick simulieren
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `sii-${businessActionId}.xml`); // Dateiname
    document.body.appendChild(link);
    link.click();

    // Aufräumen
    link.remove();
    window.URL.revokeObjectURL(url);
};
</script>

<script>
import { useEnvStore } from "@dutypay/store-modules";
//import { to } from "await-to-js";
import { mapState } from "pinia";
import { popperArrowProps } from "element-plus";
export default {
  name: "BusinessActions",
  components: {},
  computed: {
    ...mapState(useEnvStore, ["apiUrls"]),
  },
  methods: {
    printError(err) {
      if (this.debug) {
        this.$dp.log(err);
      }
    },
    truncate(input, length) {
      if (input.length > length) {
        return input.substring(0, length) + "...";
      }
      return input;
    },
  },
};
</script>

<template>
  <div>
    <h1>Geschäftsvorgangsdaten Browser</h1>
    <el-row :gutter="20">
      <el-col :span="24"> </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="16">
        <el-select
          v-model="selectedCompany"
          placeholder="DutyPay Kunde auswählen"
          clearable
          filterable
          remote
          :remote-method="getCompanies"
          @change="getReportingPeriods(selectedCompany)"
        >
          <el-option
            v-for="item in companiesList"
            :key="item.hs.company.id"
            :label="item.name.legal"
            :value="item.hs.company.id"
          />
        </el-select>
      </el-col>
      <el-col :span="8" v-loading="loadingReportingPeriods">
        <el-select
          v-model="selectedReportingPeriod"
          placeholder="Meldezeitraum auswählen"
          clearable
          filterable
          :disabled="isEmpty(selectedCompany)"
          @change="getBusinessActions"
        >
          <el-option
            v-for="item in reportingPeriods"
            :key="item.period"
            :label="item.period"
            :value="item.period"
          />
        </el-select>
      </el-col>
    </el-row>

    <div v-if="!isEmpty(selectedCompany) && !isEmpty(selectedReportingPeriod)" v-loading="loadingBusinessActions">
      <h3>Geschäftsvorgangsdaten für {{ selectedReportingPeriod }}</h3>
      <el-pagination
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="countBusinessActions"
        v-model:current-page="page"
        @change="getBusinessActions"
      />
      <el-table
        :data="businessActions"
        style="width: 100%"
      >
        <el-table-column type="expand">
        <template #default="props">
          <div m="4">
            <el-row>
              <el-col :span="8">
                <p m="t-0"><strong>Rechnungsnummer: </strong> {{ props.row.document_id }}</p>
                <p m="t-0"><strong>Rechnungsdatum: </strong> {{ dayjs(props.row.document_date).format('DD.MM.YYYY') }}</p>
                <p m="t-0"><strong>Order ID: </strong> {{ props.row.order_id }}</p>
                <p m="t-0"><strong>Transaction ID: </strong> {{ props.row.transaction_id }}</p>
                <p m="t-0"><strong>Art des Geschäfts: </strong> {{ props.row.kind_of_business }}</p>
                <p m="t-0"><strong>SourceZone USt-ID: </strong> {{ props.row.source_zone_seller_vat_nbr }}</p>
                <p m="t-0"><strong>TargetZone USt-ID: </strong> {{ props.row.target_zone_seller_vat_nbr }}</p>
              </el-col>
              <el-col :span="8">
                <p m="t-0"><strong>Beteiligte Länder: </strong> <flag-icon :code="props.row.source_zone"></flag-icon> → <flag-icon :code="props.row.target_zone"></flag-icon></p>
                <p m="t-0"><strong>Ort der Lieferung: </strong> <div v-if="props.row.vat_zone"><flag-icon :code="props.row.vat_zone"></flag-icon></div></p>
                <p m="t-0"><strong>Steuersatz: </strong> {{ includes(["SALE", "REFUND"],props.row.kind_of_business) ?  props.row.vat_rate + '%': '' }}</p>
                <p m="t-0">
                  <strong>SourceZone Brutto: </strong> {{ props.row.source_zone_gross }} {{ props.row.source_zone_currency }}<br/>
                  <strong>SourceZone Netto: </strong>{{ props.row.source_zone_net }} {{ props.row.source_zone_currency }}<br/>
                  <strong>SourceZone USt.: </strong>{{ (props.row.source_zone_gross - props.row.source_zone_net).toFixed(2) }} {{ props.row.source_zone_currency }}
                </p>
                <p m="t-0">
                  <strong>TargetZone Brutto: </strong> {{ props.row.target_zone_gross }} {{ props.row.target_zone_currency }}<br/>
                  <strong>TargetZone Netto: </strong>{{ props.row.target_zone_net }} {{ props.row.target_zone_currency }}<br/>
                  <strong>TargetZone USt.: </strong>{{ (props.row.target_zone_gross - props.row.target_zone_net).toFixed(2) }} {{ props.row.target_zone_currency }}
                </p>
              </el-col>
              <el-col :span="8">
                <p m="t-0"><strong>ASIN: </strong> {{ props.row.asin }}</p>
                <p m="t-0"><strong>Artikelname: </strong> {{ props.row.item_name }}</p>
                <p m="t-0"><strong>Artikelbeschreibung: </strong> {{ props.row.item_description }}</p>
                <hr/>
                <p m="t-0"><strong>Adresse </strong> <br/>
                  {{ props.row.transaction_partner_first_name }} {{ props.row.transaction_partner_family_name }}<br/>
                  {{ props.row.transaction_partner_street }} {{ props.row.transaction_partner_house_number }}<br/>
                  {{ props.row.transaction_partner_country_iso_code }} - {{ props.row.transaction_partner_zip }} {{ props.row.transaction_partner_city }}<br/>
                </p>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="document_id" label="R-Nr." width="150" />
        <el-table-column label="Artikel" width="200">
          <template #default="scope">
            <div class="item-description">
            {{ scope.row.item_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="kind_of_business" label="Typ" width="150" />
        <el-table-column label="Länder" width="100">
          <template #default="scope">
            <flag-icon :code="scope.row.source_zone"></flag-icon> → <flag-icon :code="scope.row.target_zone"></flag-icon>
          </template>
        </el-table-column>
        <el-table-column label="Ort der Lieferung" width="100">
          <template #default="scope">
            <div v-if="scope.row.vat_zone">
              <flag-icon :code="scope.row.vat_zone"></flag-icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Steuersatz" width="80">
          <template #default="scope"> {{ includes(["SALE", "REFUND"],scope.row.kind_of_business) ?  scope.row.vat_rate + '%': '' }} </template>
        </el-table-column>
        <el-table-column label="Preis">
          <template #default="scope">
            <div v-if="includes(['SALE', 'REFUND'],scope.row.kind_of_business)">
            {{ scope.row.vat_zone_gross }}
            {{
              scope.row.source_zone == scope.row.vat_zone
                ? scope.row.source_zone_currency
                : scope.row.target_zone_currency
            }}<br />
            ({{
              scope.row.source_zone == scope.row.vat_zone
                ? (
                    scope.row.vat_zone_gross - scope.row.source_zone_net
                  ).toFixed(2)
                : (
                    scope.row.vat_zone_gross - scope.row.target_zone_net
                  ).toFixed(2)
            }}
            {{
              scope.row.source_zone == scope.row.vat_zone
                ? scope.row.source_zone_currency
                : scope.row.target_zone_currency
            }}
            USt.)
            </div>
            <div v-if="!includes(['SALE', 'REFUND'],scope.row.kind_of_business)">
            {{ scope.row.source_zone_net }}
            {{ scope.row.source_zone_currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Aktionen" width="150">
          <template #default="scope">
            <el-button-group>
              <el-button type="primary" @click="downloadInvoicePDF(scope.row.uid)">PDF</el-button>
              <el-button type="primary" @click="downloadSIIXML(scope.row.uid)">XML</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="countBusinessActions"
        v-model:current-page="page"
        @change="getBusinessActions"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .item-description{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
